export default defineNuxtRouteMiddleware(async (_to, _from) => {
  // Grab the current Supabase user
  const user = useSupabaseUser();

  // If there is no authenticated user we have nothing to do.
  if (!user.value) return;

  // Access the profile store
  const profileStore = useProfileStore();

  /*
   * If the profile has not been hydrated yet (fresh page load or first visit)
   * we need to fetch it now. We key off `profile.id` because the store is
   * initialised with an empty string.
   */
  if (!profileStore.profile.id) {
    try {
      await profileStore.fetchProfile(user.value);
    } catch (error) {
      // We purposely swallow the error here – downstream pages can still
      // handle lack of profile, and this avoids blocking navigation.
      console.error('fetch-profile.global middleware failed to fetch profile:', error);
    }
  }
});
